export default __webpack_public_path__ + "static/media/btc-usdtlp.860c81a8.png";